import React from 'react'
import '../../Styles/reports.css'
import { ReportContextProvider } from '../../context/reportContext';
import Result from '../../Components/medicalCamp/Result';

const MedicalCamp = () => {
  return (
    <>
      <ReportContextProvider>
        <Result />
      </ReportContextProvider>

    </>
  )
}

export default MedicalCamp